export const appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#121FFF',
    colorBackground: '#f7f4f1',
    colorText: '#30313d',
    colorDanger: '#df1b41',
    fontFamily: '"Inter", sans-serif',
    spacingUnit: '4px',
    borderRadius: '8px',
    colorSuccess: 'green',
    spacingAccordionItem: '500px'
  },
  rules: {
    '.AccordionItem': {
      backgroundColor: 'transparent',
      border: '1px solid #ccc',
    },
    '.Input': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: '1px solid #cccccc',
      padding: '10px 12px',
    },
    '.Label': {
      fontFamily: '"titillium", "Helvetica", sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      color: '#333'
    },
    '.PickerItem': {
      fontFamily: '"titillium", "Helvetica", sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      color: 'rgb(102, 102, 102)'
    },
  }
}